export const renderDateString = (date: string | number | Date, language: string) =>
  new Date(date).toLocaleDateString(language === 'en' ? 'en-uk' : language, {
    day: 'numeric',
    month: 'short',
    year: 'numeric'
  });
